import React from 'react';
import { changePasswordForm } from 'form-validations';
import {
    FormGroup, Label, Input, Form, Button, FormFeedback, Row, Col, Card, CardBody
} from 'reactstrap';
import { connect } from 'react-redux';
import { LoginAction } from 'redux/actions';

const ChangePassword = (props) => {

    const [values, setvalues] = React.useState({});
    let [errors, setErrors] = React.useState({});
    let [isValid, setIsValid] = React.useState(true);
    let [isSubmitted, setIsSubmitted] = React.useState(false);

    const handleChange = (event) => {
        setvalues({ ...values, [event.target.name]: event.target.value })
    }

    React.useEffect(() => {
        const validationErrors = changePasswordForm(values);
        isValid = Object.keys(validationErrors).length === 0;
        setIsValid(isValid);
        setErrors(validationErrors);
    }, [values]);

    const handleSubmit = () => {
        setIsSubmitted(true);
        if (isValid) {
            const payload = { ...values };
            props.changePassword(payload);
        }
    }


    React.useEffect(() => {
        setvalues({});
        setIsSubmitted(false);
    }, [props.passwordChanged]);


    return (
        <Card style={{ padding: 20 }}>
            <CardBody>
                <Row>
                    <Col sm="6" style={{ margin: '10px auto' }}>
                        <Card style={{ padding: 20 }}>
                            <CardBody>
                                <Form>

                                    <FormGroup>
                                        <Label for={'currentPassword'}>{'Current Password'}</Label>
                                        <Input
                                            type="password"
                                            name="currentPassword"
                                            id="currentPassword"
                                            onChange={handleChange}
                                            autoComplete={'off'}
                                            value={(values && values.currentPassword) ? values.currentPassword : ''}
                                        />
                                        {(isSubmitted && errors.currentPassword && !values.currentPassword) && <FormFeedback >{errors.currentPassword} </FormFeedback>}
                                    </FormGroup>


                                    <FormGroup>
                                        <Label for={'newPassword'}>{'New Password'}</Label>
                                        <Input
                                            type="password"
                                            name="newPassword"
                                            id="newPassword"
                                            onChange={handleChange}
                                            autoComplete={'off'}
                                            value={(values && values.newPassword) ? values.newPassword : ''}
                                        />
                                        {(isSubmitted && errors.newPassword && !values.newPassword) && <FormFeedback >{errors.newPassword} </FormFeedback>}
                                    </FormGroup>

                                    <FormGroup>
                                        <Label for={'confirmPassword'}>{'Confirm Password'}</Label>
                                        <Input
                                            type="password"
                                            name="confirmPassword"
                                            id="confirmPassword"
                                            onChange={handleChange}
                                            autoComplete={'off'}
                                            value={(values && values.confirmPassword) ? values.confirmPassword : ''}
                                        />
                                        {(isSubmitted && errors.confirmPassword && !values.confirmPassword) && <FormFeedback >{errors.confirmPassword} </FormFeedback>}
                                    </FormGroup>
                                    <Button
                                        size="lg"
                                        color="primary"
                                        className="border-0"
                                        block
                                        onClick={handleSubmit}>
                                        Change
                                    </Button>

                                </Form>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </CardBody>
        </Card>

    );
}

const mapStateToProps = (state) => ({
    passwordChanged: (state.loginReducer && state.loginReducer.passwordChanged) ? state.loginReducer.passwordChanged : null,
});
const mapDispatchToProps = (dispatch) => ({
    changePassword: (payload) => dispatch(LoginAction.changePassword(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ChangePassword);

